import { useLiveQuery } from "dexie-react-hooks";
import { EnumTranslationRepository } from "../utils/dexie/repositories/enum-translation-repository";

export function useEnumTranslations(enumTranslationType, enumValue) {
    
    const enumTranslations = useLiveQuery(async () => {
        if (enumValue) {
            return await EnumTranslationRepository.get(enumTranslationType, enumValue);
        }

        return await EnumTranslationRepository.getAll(enumTranslationType);
    }, [enumTranslationType, enumValue])
    
    return [enumTranslations];
}